/* VAYLRO: Buy Now uses Shopify cart/add.js; photo-upload orders require verified upload integration. */
(() => {
  if (window.__vaylroBuyNowLoaded) return;
  window.__vaylroBuyNowLoaded = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vaylro-buy-now]');
    if (!button || button.disabled) return;
    const form = button.closest('form');
    const error = form?.querySelector('[data-vaylro-buy-now-error]');
    if (!form) return;
    if (error) { error.hidden = true; error.textContent = ''; }
    if (!form.reportValidity()) return;
    const personalization = form.querySelector('[data-vaylro-personalization]');
    const file = personalization?.querySelector('[data-vaylro-file]');
    if (file && file.files.length) {
      const selected = file.files[0];
      if (!['image/jpeg','image/png','image/webp'].includes(selected.type) || selected.size > 10 * 1024 * 1024) {
        if (error) { error.textContent = 'Please upload a JPG, PNG or WEBP image under 10 MB.'; error.hidden = false; }
        return;
      }
    }
    if (file && file.files.length) {
      if (error) { error.textContent = 'For photo-personalized orders, please use Add to Cart until photo upload is verified for checkout.'; error.hidden = false; }
      return;
    }
    const data = new FormData(form);
    // Quantity selector in the Tinker theme can live outside the standard input field.
    const selector = form.closest('product-form-component')?.querySelector('quantity-selector');
    const quantity = selector?.querySelector('input[name="quantity"]')?.value || form.querySelector('[name="quantity"]')?.value || '1';
    data.set('quantity', quantity);
    if (!data.get('id')) {
      if (error) { error.textContent = 'Please choose your product options first.'; error.hidden = false; }
      return;
    }
    button.disabled = true;
    const label = button.innerHTML;
    button.textContent = 'Preparing checkout…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', { method:'POST', body:data, headers:{'Accept':'application/json'} });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');
      window.location.assign(root + 'checkout');
    } catch (e) {
      if (error) { error.textContent = e.message || 'Unable to proceed. Please try again.'; error.hidden = false; }
      button.disabled = false;
      button.innerHTML = label;
    }
  });
})();
